import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl} from '@angular/cdk/tree';
import { Component, EventEmitter, Injectable, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeModule } from '@angular/material/tree';
import { BehaviorSubject, Observable } from 'rxjs';


/**
 * Node for to-do item
 */
export class DptoNode {
  uos?: DptoNode[];
  nombre?: string;
  id?: String;
}

/** Flat to-do item node with expandable and level information */
export class DptoFlatNode {
  id?: string;
  nombre?: string;
  level?: number;
  expandable?: boolean;
}


@Injectable({ providedIn: "root" })
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<any[]>([]);
  externalData?: any[];
  treeData?: any[];

  get data(): any[] {
    return this.dataChange.value;
  }

  constructor() {
    
    
  }

  public initialize() {
    this.treeData = this.externalData;
    const data = this.externalData;
    if(data){
      this.dataChange.next(data);
    }
  }

  public filter(filterText: string) {
    let filteredTreeData;
    if (filterText) {
      // Filter the tree
      function filter(array: any, text: String) {
        //var data: any[] = []
        const getChildren = (result: any, object: any) => {
          //var data = {...object};
          //data.uos = []          
          if (object.nombre.toLowerCase().includes(text.toLowerCase())) {
            result.push(object);
            return result;
          }
          if (Array.isArray(object.uos) && object.uos.length>0) {
            const uos = object.uos.reduce(getChildren, []);
            if (uos.length) {
              result.push({ ...object, uos });
            }
          }
          return result;
        };

        return array.reduce(getChildren, []);
      }

      filteredTreeData = filter(this.treeData, filterText);
    } else {
      // Return the initial tree
      filteredTreeData = this.treeData;
    }

    // Build the tree nodes from Json object. The result is a list of `TodoItemNode` with nested
    // file node as children.
    const data = filteredTreeData;
    // Notify the change.
    this.dataChange.next(data);
  }
}

@Component({
    selector: 'app-tree-autocomplete',
    imports: [
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule,
        MatSelectModule,
        MatToolbarModule,
        MatTreeModule,
        MatIconModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        ReactiveFormsModule
    ],
    providers: [ChecklistDatabase],
    templateUrl: './tree-autocomplete.component.html',
    styleUrl: './tree-autocomplete.component.scss'
})

export class TreeAutocompleteComponent implements OnInit, OnChanges {

  @Input() dptos!: any[]
  @Output() onSelected = new EventEmitter<DptoNode>()
  
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<DptoFlatNode, DptoNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<DptoNode, DptoFlatNode>();

  treeControl: FlatTreeControl<DptoFlatNode>;

  treeFlattener: MatTreeFlattener<DptoNode, DptoFlatNode>;

  dataSource: MatTreeFlatDataSource<DptoNode, DptoFlatNode>;

  dptoSelected?: DptoNode;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<DptoFlatNode>(true /* multiple */);

  /// Filtering
  myControl = new FormControl();
  filteredOptions?: Observable<string[]>;

  constructor(private _database: ChecklistDatabase) {    
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    this.treeControl = new FlatTreeControl<DptoFlatNode>(
      this.getLevel,
      this.isExpandable
    );
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );

    _database.dataChange.subscribe((data: any) => {
      this.dataSource.data = data;
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.dptos =  changes["dptos"].currentValue
    this.ngOnInit()
  }

  onOptionSelected(event: any) {
    this.dptoSelected = event.option.value;
    this.onSelected.emit(event.option.value)
    // Aquí puedes realizar cualquier acción con el valor seleccionado
  }
  ngOnInit() { 
    this._database.externalData = this.dptos;
    this._database.initialize()
  }

  getLevel = (node: DptoFlatNode) => node.level || 0;

  isExpandable = (node: DptoFlatNode) => node.expandable || false;

  getChildren = (node: any): any[] | undefined => node.uos;

  hasChild = (_: number, _nodeData: DptoFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: DptoFlatNode) => _nodeData.nombre === "";

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: any, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.nombre === node.nombre
        ? existingNode
        : new DptoFlatNode();
    flatNode.nombre = node.nombre;
    flatNode.id = node.id;
    flatNode.level = level;
    flatNode.expandable = !!node.uos && node.uos.length>0;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  displayFn(deparatamento: any): string {
    return deparatamento && deparatamento.nombre ? deparatamento.nombre : '';
  }

  filterChanged(ev: any) {
    const filterText = ev.target.value
    // ChecklistDatabase.filter method which actually filters the tree and gives back a tree structure
    this._database.filter(filterText.toString());
    if (filterText) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }    
  }

  onLostFocus(){
    if(this.dptoSelected){
      if (this.myControl.value !== this.dptoSelected.nombre){        
        this.myControl.setValue(this.dptoSelected.nombre);
      }
    }
  }
}